/**
 * The cookie that remembers a matched UTM campaign for the rest of the visit
 * (WAT-12828). The server resolver queues it in cookieList and reads it back;
 * the browser bootstraps write it. Both sides import this one name — a
 * `utCode` / `utcode` case mismatch left it unwritten from 2025-09 to 2026-11.
 */
export const UTM_COOKIE = "utcode";
